import { Button, Form, InputNumber, Select } from 'antd';
import styled from 'styled-components';
import { GreenColors, NeutralColors, RedColors } from 'theme';

interface SumValueProps {
  isValid?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const SeasonItem = styled(Form.Item)`
  flex: 1;
  margin: 0;
`;

const PercentageItem = styled(Form.Item)`
  width: 110px;
  margin: 0;
`;

const PercentageInput = styled(InputNumber)`
  width: 100%;
`;

const SeasonSelect = styled(Select)`
  width: 100%;
`;

const RemoveButton = styled(Button)`
  color: ${NeutralColors[70]};
`;

const AddButton = styled(Button)`
  align-self: flex-start;
`;

const SumRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid ${NeutralColors[20]};
  color: ${NeutralColors[80]};
  font-size: 14px;
`;

const SumValue = styled.span<SumValueProps>`
  font-weight: 600;
  color: ${({ isValid }) => (isValid ? GreenColors[60] : RedColors[60])};
`;

export {
  AddButton,
  Container,
  PercentageInput,
  PercentageItem,
  RemoveButton,
  Row,
  SeasonItem,
  SeasonSelect,
  SumRow,
  SumValue,
};
